import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row fit no-wrap q-pb-lg"
}
const _hoisted_2 = {
  class: "col-grow",
  style: {"overflow":"auto"}
}
const _hoisted_3 = { class: "row fit no-wrap q-pb-lg" }
const _hoisted_4 = {
  class: "col-grow",
  style: {"overflow":"auto"}
}
const _hoisted_5 = {
  class: "row fit flex no-wrap justify-between q-pb-xs",
  style: {"width":"100%"}
}
const _hoisted_6 = { class: "q-pr-sm" }
const _hoisted_7 = { class: "q-pl-sm" }
const _hoisted_8 = { class: "col col-grow q-pl-sm" }

import { ref, computed } from 'vue'

import { EnumRequestedAdjustmentsInstitucionalModalType, EnumButtonSizes } from '@/enums/enums'
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'
import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'
import messages from '@/utils/messages'


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalRequestAdjustmentsInstitucional',
  setup(__props) {

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()

// ✅ ref local — igual campaignStore.refRequestedAdjustments nas campanhas
const refRequestedAdjustments = ref('')

const institutionalInfo = computed(() => {
  return (
    institutionalStore.reviewData ||
    institutionalStore.institutionalDetail ||
    institutionalStore.institutionalDraft
  )
})

const showOkButton = computed(() => {
  const status = institutionalInfo.value?.status
  return (
    status !== CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id &&
    status !== CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id
  )
})

const onOkBtnClick = () => {
  if (refRequestedAdjustments.value.trim() && institutionalStore.institutionalDetail) {
    institutionalStore.institutionalDetail.comentarioAjuste = refRequestedAdjustments.value
    refRequestedAdjustments.value = ''
  }
  pagesUtilStore.showModalRequestAdjustmentsInstitucional = false
}





const disableEditAskAdjustmen = computed(() => {
  return (
    institutionalStore.institutionalDetail?.status === CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.id ||
    institutionalStore.institutionalDetail?.status === CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED_AGAIN.id ||
    institutionalStore.institutionalDetail?.status === CONST_INSTITUTIONAL_STATUS.PUBLISHED.id ||
    institutionalStore.institutionalDetail?.status === CONST_INSTITUTIONAL_STATUS.APPROVED.id
  )
})

// ✅ Solicitar Ajuste — igual sendRequestedAdjustmentsFocusedCampaign
const onSendRequestedAdjustmentsBtnClick = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    await institutionalStore.requestAdjustments(id, refRequestedAdjustments.value.trim())

    refRequestedAdjustments.value = ''
    messages.showSuccessMsg('Solicitação de ajustes realizada com sucesso!')
    pagesUtilStore.showModalRequestAdjustmentsInstitucional = false

  } catch (error: any) {
    messages.showErrorMsg(error.message)
  } finally {
    pagesUtilStore.showLoading = false
  }
}

// ✅ Solicitar Reajuste — igual sendRequestedAdjustmentsAgainFocusedCampaign
const onSendRequestedAdjustmentsAgainBtnClick = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    await institutionalStore.requestReadjustments(id, refRequestedAdjustments.value.trim())

    refRequestedAdjustments.value = ''
    messages.showSuccessMsg('Solicitação de reajuste realizada com sucesso!')
    pagesUtilStore.showModalRequestAdjustmentsInstitucional = false

  } catch (error: any) {
    messages.showErrorMsg(error.message)
  } finally {
    pagesUtilStore.showLoading = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_c_modal_title = _resolveComponent("c-modal-title")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_c_q_btn = _resolveComponent("c-q-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_dialog, {
      modelValue: _unref(pagesUtilStore).showModalRequestAdjustmentsInstitucional,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(pagesUtilStore).showModalRequestAdjustmentsInstitucional) = $event)),
      "no-backdrop-dismiss": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: "midia-app-padding-modal",
          style: {"width":"448px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_c_modal_title, {
                propModalTitle: "Solicitar Ajuste",
                propModalDescription: (
              (_unref(pagesUtilStore).modalRequestedAdjustmentsInstitucionalModalType == _unref(EnumRequestedAdjustmentsInstitucionalModalType).CREATE) ? 'Informe os ajustes necessários:' :
              (_unref(pagesUtilStore).modalRequestedAdjustmentsInstitucionalModalType == _unref(EnumRequestedAdjustmentsInstitucionalModalType).UPDATE) ? 'Verifique os Ajustes Solicitados' :
              ''
            )
              }, null, 8, ["propModalDescription"]),
              (_unref(institutionalStore).institutionalDetail?.comentarioAjuste)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_q_input, {
                        style: {"position":"relative"},
                        modelValue: _unref(institutionalStore).institutionalDetail.comentarioAjuste,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(institutionalStore).institutionalDetail.comentarioAjuste) = $event)),
                        type: "textarea",
                        maxlength: "255",
                        color: "globalAppPrimaryColor",
                        "bg-color": "globalAppDefaultBackgroundColor",
                        outlined: "",
                        dense: "",
                        placeholder: "Digite aqui...",
                        "input-class": "midia-app-content-lg",
                        readonly: true
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_q_input, {
                    style: {"position":"relative"},
                    modelValue: refRequestedAdjustments.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refRequestedAdjustments).value = $event)),
                    type: "textarea",
                    maxlength: "255",
                    color: "globalAppPrimaryColor",
                    "bg-color": "globalAppDefaultBackgroundColor",
                    outlined: "",
                    dense: "",
                    placeholder: "Digite aqui...",
                    "input-class": "midia-app-content-lg",
                    disable: disableEditAskAdjustmen.value
                  }, null, 8, ["modelValue", "disable"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createVNode(_component_c_q_btn, {
                    id: "btn-cancel",
                    propBtnLabel: "Cancelar",
                    propBtnTransparent: true,
                    propBtnSize: _unref(EnumButtonSizes).LARGE_1
                  }, null, 8, ["propBtnSize"]), [
                    [_directive_close_popup]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (showOkButton.value)
                    ? (_openBlock(), _createBlock(_component_c_q_btn, {
                        key: 0,
                        id: "btn-adjustment",
                        propBtnLabel: "OK",
                        propBtnTransparent: false,
                        propBtnSize: _unref(EnumButtonSizes).LARGE_1,
                        propBtnFunction: onOkBtnClick
                      }, null, 8, ["propBtnSize"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (_unref(institutionalStore).institutionalDetail?.status === _unref(CONST_INSTITUTIONAL_STATUS).ON_APPROVAL.id)
                    ? (_openBlock(), _createBlock(_component_c_q_btn, {
                        key: 0,
                        id: "btn-send-requested-adjustments",
                        style: {"width":"100%"},
                        propBtnLabel: "Enviar",
                        propBtnFunction: onSendRequestedAdjustmentsBtnClick,
                        propBtnTransparent: false,
                        propBtnSize: _unref(EnumButtonSizes).LARGE_1,
                        disable: !refRequestedAdjustments.value?.trim()
                      }, null, 8, ["propBtnSize", "disable"]))
                    : _createCommentVNode("", true),
                  (_unref(institutionalStore).institutionalDetail?.status === _unref(CONST_INSTITUTIONAL_STATUS).ON_RE_APPROVAL.id)
                    ? (_openBlock(), _createBlock(_component_c_q_btn, {
                        key: 1,
                        id: "btn-send-requested-adjustments",
                        style: {"width":"100%"},
                        propBtnLabel: "Enviar",
                        propBtnFunction: onSendRequestedAdjustmentsAgainBtnClick,
                        propBtnTransparent: false,
                        propBtnSize: _unref(EnumButtonSizes).LARGE_1,
                        disable: !refRequestedAdjustments.value?.trim()
                      }, null, 8, ["propBtnSize", "disable"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})